import { api, publicApi } from "@/lib/api";
import type { AuthResponse, MicrositeUser } from "@/types/api";

export interface SignupPayload {
  name: string;
  email: string;
  password: string;
  phone?: string;
}

export interface LoginPayload {
  email: string;
  password: string;
}

export async function signup(payload: SignupPayload): Promise<{ ok: boolean; message: string }> {
  const { data } = await publicApi.post<{ ok: boolean; message: string }>("/microsite/auth/signup", payload);
  return data;
}

export async function login(payload: LoginPayload): Promise<AuthResponse> {
  const { data } = await publicApi.post<AuthResponse>("/microsite/auth/login", payload);
  return data;
}

export async function logout(): Promise<void> {
  await api.post("/microsite/auth/logout");
}

export async function verifyEmail(token: string): Promise<{ ok: boolean; message?: string }> {
  const { data } = await publicApi.post<{ ok: boolean; message?: string }>("/microsite/auth/verify", { token });
  return data;
}

export async function resendVerification(email: string): Promise<{ ok: boolean }> {
  const { data } = await publicApi.post<{ ok: boolean }>("/microsite/auth/resend-verification", { email });
  return data;
}

export async function forgotPassword(email: string): Promise<{ ok: boolean }> {
  const { data } = await publicApi.post<{ ok: boolean }>("/microsite/auth/forgot-password", { email });
  return data;
}

export async function resetPassword(token: string, newPassword: string): Promise<{ ok: boolean; message?: string }> {
  const { data } = await publicApi.post<{ ok: boolean; message?: string }>("/microsite/auth/reset-password", { token, newPassword });
  return data;
}

export async function fetchMe(): Promise<MicrositeUser> {
  const { data } = await api.get<{ user: MicrositeUser }>("/microsite/auth/me");
  return data.user;
}

/** Lock the account to a registration path ("corporate" | "pwd"). */
export async function setRegistrationType(type: "corporate" | "pwd"): Promise<MicrositeUser> {
  const { data } = await api.put<{ user: MicrositeUser }>("/microsite/auth/registration-type", { type });
  return data.user;
}
